

const initialState = {
  isLoading:false
}


export default function register(state = initialState, action) {
  switch (action.type) {
    case 'POST_REGISTRATION_REQUEST':
      return {
        ...state,
        isLoading:true
      }
  
    case 'POST_REGISTRATION_SUCCESS':
    {
      const { response } = action;
      return {
        ...state,
        isLoading:false,
        response,
        error:''
      }
    }
  
    case 'POST_REGISTRATION_ERROR':
    {
      const { error } = action;
      return {
        ...state,
        isLoading:false,
        error,
        response: ''
      }
    }
    default:
      return state;
  }
}







// WEBPACK FOOTER //
// ./src/reducers/auth/register.js